import React from 'react';
import logoImg from "../../../img/logo.svg";

const Navbar: React.FC = () => {
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <a className="navbar-brand" href="https://ravendb.net/">
          <img className="navbar-logo" src={logoImg} alt="RavenDB Logo" />
        </a>
        <a className="nav-link active contact-link" href="https://ravendb.net/contact">Contact</a>
      </div>
    </nav>
  );
};

export default Navbar;